function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".rocket_svg__st0{fill:none}.rocket_svg__st1{fill:#106a5e}.rocket_svg__st16{opacity:.9;enable-background:new}.rocket_svg__st16,.rocket_svg__st17,.rocket_svg__st18{fill:#fff}.rocket_svg__st18{opacity:.7;enable-background:new}.rocket_svg__st19{opacity:.3}.rocket_svg__st32{fill:none;stroke:#ebeef0;stroke-width:.6068;stroke-miterlimit:10}");

var _ref3 =
/*#__PURE__*/
React.createElement("pattern", {
  y: 598,
  width: 28.8,
  height: 28.8,
  patternUnits: "userSpaceOnUse",
  id: "rocket_svg__q",
  viewBox: "3.4 -31.6 28.8 28.8",
  overflow: "visible"
}, React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-31.6h28.8v28.8H3.4z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st1",
  d: "M2.7-34.6L.1-30.1c-.2.4-.1.9.3 1.2.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.6c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM9.9-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.5.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3-.2.1-.3.2-.4.3zM9.9-13L7.3-8.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L11.3-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-13l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L25.7-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-20.2L.1-15.7c-.2.4-.1.9.3 1.1.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-5.8L.1-1.3c-.2.4-.1.9.3 1.1.1.2.3.2.4.2H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L4.1-5.7c-.2-.4-.7-.5-1.1-.3-.1 0-.2.1-.3.2zM17.1-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("pattern", {
  y: 598,
  width: 28.8,
  height: 28.8,
  patternUnits: "userSpaceOnUse",
  id: "rocket_svg__r",
  viewBox: "3.4 -31.6 28.8 28.8",
  overflow: "visible"
}, React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-31.6h28.8v28.8H3.4z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st1",
  d: "M2.7-34.6L.1-30.1c-.2.4-.1.9.3 1.2.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.6c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM9.9-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.5.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3-.2.1-.3.2-.4.3zM9.9-13L7.3-8.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L11.3-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-13l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L25.7-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-20.2L.1-15.7c-.2.4-.1.9.3 1.1.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-5.8L.1-1.3c-.2.4-.1.9.3 1.1.1.2.3.2.4.2H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L4.1-5.7c-.2-.4-.7-.5-1.1-.3-.1 0-.2.1-.3.2zM17.1-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("pattern", {
  y: 598,
  width: 28.8,
  height: 28.8,
  patternUnits: "userSpaceOnUse",
  id: "rocket_svg__s",
  viewBox: "3.4 -31.6 28.8 28.8",
  overflow: "visible"
}, React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-31.6h28.8v28.8H3.4z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st1",
  d: "M2.7-34.6L.1-30.1c-.2.4-.1.9.3 1.2.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.6c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM9.9-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.5.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3-.2.1-.3.2-.4.3zM9.9-13L7.3-8.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L11.3-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-13l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L25.7-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-20.2L.1-15.7c-.2.4-.1.9.3 1.1.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-5.8L.1-1.3c-.2.4-.1.9.3 1.1.1.2.3.2.4.2H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L4.1-5.7c-.2-.4-.7-.5-1.1-.3-.1 0-.2.1-.3.2zM17.1-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3z"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("pattern", {
  y: 598,
  width: 28.8,
  height: 28.8,
  patternUnits: "userSpaceOnUse",
  id: "rocket_svg__t",
  viewBox: "3.4 -31.6 28.8 28.8",
  overflow: "visible"
}, React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-31.6h28.8v28.8H3.4z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M3.4-2.8h28.8v-28.8H3.4v28.8z"
}), React.createElement("path", {
  className: "rocket_svg__st1",
  d: "M2.7-34.6L.1-30.1c-.2.4-.1.9.3 1.2.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.6c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM9.9-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-27.4l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.5.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3-.2.1-.3.2-.4.3zM9.9-13L7.3-8.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L11.3-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM24.3-13l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L25.7-13c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-34.6l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-20.2L.1-15.7c-.2.4-.1.9.3 1.1.1.1.3.1.4.1H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM17.1-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-20.2l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM2.7-5.8L.1-1.3c-.2.4-.1.9.3 1.1.1.2.3.2.4.2H6c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4L4.1-5.7c-.2-.4-.7-.5-1.1-.3-.1 0-.2.1-.3.2zM17.1-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3zM31.5-5.8l-2.6 4.5c-.2.4-.1.9.3 1.1.1.1.3.1.4.1h5.2c.5 0 .8-.4.8-.8 0-.1 0-.3-.1-.4l-2.6-4.5c-.2-.4-.7-.5-1.1-.3l-.3.3z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "rocket_svg__SVGID_1_",
  cx: 302,
  cy: 299,
  r: 294
}));

var _ref8 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "rocket_svg__SVGID_2_"
}, React.createElement("use", {
  xlinkHref: "#rocket_svg__SVGID_1_",
  overflow: "visible"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#rocket_svg__SVGID_2_)"
}, React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 299,
  y1: 334.01,
  x2: 299,
  y2: -183.42,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#d4f2ff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ade4f7"
})), React.createElement("path", {
  d: "M-21-274h640V806H-21V-274z",
  fill: "url(#rocket_svg__SVGID_3_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: -42.95,
  y1: 425.064,
  x2: 255.02,
  y2: 425.064,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#d4f2ff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("path", {
  d: "M235.3 470.7c-17.3-20.8-48.2-23.6-69-6.3-.1.1-.3.2-.4.3-8.6-15.7-25.1-25.5-43-25.5-1.6 0-3.3.1-4.9.2-7.1-26.1-34.1-41.5-60.2-34.3-16.1 4.4-28.8 16.7-33.8 32.7-2.4-.3-4.8-.5-7.2-.5-21.1 0-39.8 13.5-46.5 33.5h265v-.1z",
  fill: "url(#rocket_svg__SVGID_4_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 6255.78,
  y1: 400.256,
  x2: 6553.75,
  y2: 400.256,
  gradientTransform: "matrix(-1 0 0 1 6926.2 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#d4f2ff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("path", {
  d: "M392.2 446c17.3-20.8 48.2-23.6 69-6.3.1.1.3.2.4.3 8.6-15.7 25.1-25.5 43-25.5 1.7 0 3.3.1 4.9.2 7.1-26.1 34-41.5 60.1-34.5 16.2 4.4 29 16.7 34 32.7 2.4-.3 4.8-.5 7.2-.5 21.1 0 39.8 13.5 46.5 33.5l-265.1.1z",
  fill: "url(#rocket_svg__SVGID_5_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: -21,
  y1: 74.3,
  x2: 619,
  y2: 74.3,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#d4f2ff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ffd871"
})), React.createElement("path", {
  d: "M-21 276v170.6l640-640V-274h-90L-21 276z",
  opacity: 0.15,
  fill: "url(#rocket_svg__SVGID_6_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 30,
  y1: 499.5,
  x2: 619,
  y2: 499.5,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#d4f2ff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ffd871"
})), React.createElement("path", {
  d: "M200.6 806L619 387.6V217L30 806h170.6z",
  opacity: 0.15,
  fill: "url(#rocket_svg__SVGID_7_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_8_",
  gradientUnits: "userSpaceOnUse",
  x1: -21,
  y1: 160.3,
  x2: 619,
  y2: 160.3,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#d4f2ff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ffd871"
})), React.createElement("path", {
  d: "M-21 577.6l640-640V-233L-21 407v170.6z",
  opacity: 0.15,
  fill: "url(#rocket_svg__SVGID_8_)"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_9_",
  gradientUnits: "userSpaceOnUse",
  x1: 350.809,
  y1: -2.626,
  x2: 249.191,
  y2: 576.626,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#1d3167"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#050033"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 300,
  cy: 299,
  r: 294,
  fill: "url(#rocket_svg__SVGID_9_)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st0",
  cx: 300.9,
  cy: 300,
  r: 294
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "rocket_svg__st0",
  d: "M465.9 232.8h45.7v11.8c0 7.2-5.8 13-13 13h-19.8c-7.2 0-13-5.8-13-13l.1-11.8z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "rocket_svg__SVGID_10_",
  transform: "rotate(-45.001 387.245 172.258)",
  d: "M290.5 75.5H484V269H290.5z"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "rocket_svg__SVGID_11_"
}, React.createElement("use", {
  xlinkHref: "#rocket_svg__SVGID_10_",
  overflow: "visible"
}));

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.53,
  clipPath: "url(#rocket_svg__SVGID_11_)"
}, React.createElement("defs", null, React.createElement("path", {
  id: "rocket_svg__SVGID_12_",
  d: "M312.8 169c-15.7 0-28.5 46.9-28.5 62.6v187.9h57V231.7c0-15.8-12.8-62.7-28.5-62.7z"
})), React.createElement("clipPath", {
  id: "rocket_svg__SVGID_13_"
}, React.createElement("use", {
  xlinkHref: "#rocket_svg__SVGID_12_",
  overflow: "visible"
})), React.createElement("g", {
  opacity: 0.25,
  clipPath: "url(#rocket_svg__SVGID_13_)"
}, React.createElement("pattern", {
  id: "rocket_svg__SVGID_14_",
  xlinkHref: "#rocket_svg__q",
  patternTransform: "matrix(.21 0 0 .21 -11498.935 2994.163)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M242.3 159.9h55.5v55.5h-55.5v-55.5z",
  fill: "url(#rocket_svg__SVGID_14_)"
}), React.createElement("pattern", {
  id: "rocket_svg__SVGID_15_",
  xlinkHref: "#rocket_svg__r",
  patternTransform: "matrix(.21 0 0 .21 -11496.505 2994.163)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M298.3 159.9h55.5v55.5h-55.5v-55.5z",
  fill: "url(#rocket_svg__SVGID_15_)"
}), React.createElement("pattern", {
  id: "rocket_svg__SVGID_16_",
  xlinkHref: "#rocket_svg__s",
  patternTransform: "matrix(.21 0 0 .21 -11498.935 2996.592)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M242.3 215.9h55.5v55.5h-55.5v-55.5z",
  fill: "url(#rocket_svg__SVGID_16_)"
}), React.createElement("pattern", {
  id: "rocket_svg__SVGID_17_",
  xlinkHref: "#rocket_svg__t",
  patternTransform: "matrix(.21 0 0 .21 -11496.505 2996.592)",
  opacity: 0.25
}), React.createElement("path", {
  d: "M298.3 215.9h55.5v55.5h-55.5v-55.5z",
  fill: "url(#rocket_svg__SVGID_17_)"
})));

var _ref17 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 154.5,
  cy: 133.2,
  r: 2
});

var _ref18 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 428.1,
  cy: 262.4,
  r: 2
});

var _ref19 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 466,
  cy: 437.7,
  r: 1.5
});

var _ref20 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 214.9,
  cy: 195.9,
  r: 1.5
});

var _ref21 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 269.6,
  cy: 431.3,
  r: 1.5
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 348.5,
  cy: 305.8,
  r: 1.5
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 116.6,
  cy: 328.4,
  r: 1.5
});

var _ref24 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 357.5,
  cy: 171.1,
  r: 1.5
});

var _ref25 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 200.4,
  cy: 281.2,
  r: 1.5
});

var _ref26 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 385.8,
  cy: 73.2,
  r: 1.5
});

var _ref27 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 438.8,
  cy: 136.9,
  r: 2
});

var _ref28 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 192.8,
  cy: 360.7,
  r: 2
});

var _ref29 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 388.5,
  cy: 391,
  r: 4.3
});

var _ref30 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 289.1,
  cy: 100.6,
  r: 4.3
});

var _ref31 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 133.4,
  cy: 442.1,
  r: 4.3
});

var _ref32 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 106.3,
  cy: 225.6,
  r: 4.3
});

var _ref33 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 292.2,
  cy: 254.9,
  r: 4.3
});

var _ref34 =
/*#__PURE__*/
React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 492.7,
  cy: 207,
  r: 4.3
});

var _ref35 =
/*#__PURE__*/
React.createElement("g", {
  className: "rocket_svg__st19"
}, React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 267.5,
  cy: 303.2,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 174,
  cy: 105.8,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 262.5,
  cy: 240.6,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 339.8,
  cy: 84.2,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 238.3,
  cy: 118.1,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 378,
  cy: 211.7,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 171.6,
  cy: 189.1,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 309.7,
  cy: 199.6,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 111,
  cy: 230.8,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 110.6,
  cy: 171,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 350.2,
  cy: 158.7,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 254.9,
  cy: 52.3,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 177.5,
  cy: 259.8,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 420.6,
  cy: 140.6,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 336.7,
  cy: 273.7,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 246.4,
  cy: 172.3,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 112.6,
  cy: 107.2,
  r: 3.1
}));

var _ref36 =
/*#__PURE__*/
React.createElement("g", {
  className: "rocket_svg__st19"
}, React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 506.5,
  cy: 526.3,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 413.1,
  cy: 328.9,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 472.2,
  cy: 213.8,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 501.6,
  cy: 463.7,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 578.8,
  cy: 307.3,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 477.3,
  cy: 341.2,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 410.6,
  cy: 412.2,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 548.7,
  cy: 422.7,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 350.1,
  cy: 453.9,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 349.7,
  cy: 394.1,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 589.3,
  cy: 381.8,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 494,
  cy: 275.4,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 416.5,
  cy: 482.9,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 575.7,
  cy: 496.8,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 485.5,
  cy: 395.4,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 351.7,
  cy: 330.3,
  r: 3.1
}));

var _ref37 =
/*#__PURE__*/
React.createElement("g", {
  className: "rocket_svg__st19"
}, React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 181.4,
  cy: 595.5,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 88,
  cy: 398.1,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 147.1,
  cy: 283,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 176.5,
  cy: 532.9,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 253.7,
  cy: 376.5,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 152.2,
  cy: 410.4,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 292,
  cy: 504,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 85.5,
  cy: 481.4,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 223.6,
  cy: 491.9,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st17",
  cx: 25,
  cy: 523.1,
  r: 1.1
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 24.6,
  cy: 463.3,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st16",
  cx: 264.2,
  cy: 451,
  r: 1.4
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 168.9,
  cy: 344.6,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 91.4,
  cy: 552.1,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 334.6,
  cy: 432.8,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 250.6,
  cy: 566,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 160.4,
  cy: 464.6,
  r: 3.1
}), React.createElement("circle", {
  className: "rocket_svg__st18",
  cx: 26.6,
  cy: 399.5,
  r: 3.1
}));

var _ref38 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("defs", null, React.createElement("circle", {
  id: "rocket_svg__SVGID_18_",
  cx: 301,
  cy: 299,
  r: 293
})), React.createElement("clipPath", {
  id: "rocket_svg__SVGID_19_"
}, React.createElement("use", {
  xlinkHref: "#rocket_svg__SVGID_18_",
  overflow: "visible"
})), React.createElement("g", {
  clipPath: "url(#rocket_svg__SVGID_19_)"
}, React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_20_",
  gradientUnits: "userSpaceOnUse",
  x1: 331,
  y1: 594.28,
  x2: 331,
  y2: 409.05,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#f7931e"
}), React.createElement("stop", {
  offset: 0.27,
  stopColor: "#f7901e"
}), React.createElement("stop", {
  offset: 0.45,
  stopColor: "#f6881f"
}), React.createElement("stop", {
  offset: 0.6,
  stopColor: "#f5791f"
}), React.createElement("stop", {
  offset: 0.73,
  stopColor: "#f36420"
}), React.createElement("stop", {
  offset: 0.85,
  stopColor: "#f14922"
}), React.createElement("stop", {
  offset: 0.96,
  stopColor: "#ee2823"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ed1c24"
})), React.createElement("path", {
  d: "M304.6 602.2h52.8c-1.5-5.6-2.9-11.2-4.2-16.9C339.5 527 338.9 481 339.5 430c-.4 0-5.3-9-5.7-9h-5.6c-.4 0-5.1 8.2-5.5 8.2.6 51-.2 97.8-14 156.1-1.3 5.7-2.6 11.4-4.1 16.9z",
  opacity: 0.9,
  fill: "url(#rocket_svg__SVGID_20_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_21_",
  gradientUnits: "userSpaceOnUse",
  x1: 331.3,
  y1: 975.87,
  x2: 331.3,
  y2: 417.95,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fcee21"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fbb03b"
})), React.createElement("path", {
  d: "M304.9 975.8h52.8c-1.5-16.8-2.9-33.8-4.2-50.9-13.7-175.8-18.9-341.5-18.3-495.1h-7.9c.6 153.6-4.5 319.3-18.3 495.1-1.2 17.1-2.6 34-4.1 50.9z",
  opacity: 0.46,
  fill: "url(#rocket_svg__SVGID_21_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_22_",
  gradientUnits: "userSpaceOnUse",
  x1: 294.5,
  y1: 594.28,
  x2: 294.5,
  y2: 409.05,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#f7931e"
}), React.createElement("stop", {
  offset: 0.27,
  stopColor: "#f7901e"
}), React.createElement("stop", {
  offset: 0.45,
  stopColor: "#f6881f"
}), React.createElement("stop", {
  offset: 0.6,
  stopColor: "#f5791f"
}), React.createElement("stop", {
  offset: 0.73,
  stopColor: "#f36420"
}), React.createElement("stop", {
  offset: 0.85,
  stopColor: "#f14922"
}), React.createElement("stop", {
  offset: 0.96,
  stopColor: "#ee2823"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ed1c24"
})), React.createElement("path", {
  d: "M268.1 602.2h52.8c-1.5-5.6-2.9-11.2-4.2-16.9C303 527 302.4 481 303 430c-.4 0-5.3-9-5.7-9h-5.6c-.4 0-5.1 8.2-5.5 8.2.6 51-.2 97.8-14 156.1-1.3 5.7-2.6 11.4-4.1 16.9z",
  opacity: 0.9,
  fill: "url(#rocket_svg__SVGID_22_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_23_",
  gradientUnits: "userSpaceOnUse",
  x1: 294.8,
  y1: 975.87,
  x2: 294.8,
  y2: 417.95,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fcee21"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fbb03b"
})), React.createElement("path", {
  d: "M268.4 975.8h52.8c-1.5-16.8-2.9-33.8-4.2-50.9-13.7-175.8-18.9-341.5-18.3-495.1h-7.9c.6 153.6-4.5 319.3-18.3 495.1-1.3 17.1-2.6 34-4.1 50.9z",
  opacity: 0.46,
  fill: "url(#rocket_svg__SVGID_23_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_24_",
  gradientUnits: "userSpaceOnUse",
  x1: -374.745,
  y1: 230.931,
  x2: -223.446,
  y2: 446.621,
  gradientTransform: "rotate(45.001 -105.147 1316.002)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#ff9271"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ffd871"
})), React.createElement("circle", {
  cx: 425.7,
  cy: 619,
  r: 98.3,
  fill: "url(#rocket_svg__SVGID_24_)"
}), React.createElement("path", {
  d: "M496.4 550.7l-139 139c38.6 38.1 100.9 37.7 139-.9 37.8-38.3 37.8-99.8 0-138.1z",
  fill: "#ffd871"
}), React.createElement("path", {
  d: "M301.4 423.5h-13.3l-1.9 6.2h17.1l-1.9-6.2zM299 419.6h-8.5l-1.2 3.9h10.9l-1.2-3.9zM324.2 423.5h13.3l1.9 6.2h-17.1l1.9-6.2zM326.6 419.6h8.5l1.2 3.9h-10.9l1.2-3.9z"
}), React.createElement("path", {
  d: "M312.8 169c-15.7 0-28.5 46.9-28.5 62.6v188h57V231.7c0-15.8-12.8-62.7-28.5-62.7z",
  fill: "#fbfcfc"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_25_",
  gradientUnits: "userSpaceOnUse",
  x1: 253.385,
  y1: 196.262,
  x2: 315.085,
  y2: 281.682,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ebeef0"
})), React.createElement("path", {
  d: "M341.3 419.6V231.7c0-15.7-12.8-62.6-28.5-62.6v250.6h28.5v-.1z",
  fill: "url(#rocket_svg__SVGID_25_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_26_",
  gradientUnits: "userSpaceOnUse",
  x1: 282.889,
  y1: 345.387,
  x2: 325.129,
  y2: 394.267,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#57c2be"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00a9e1"
})), React.createElement("path", {
  d: "M284.3 364.5h57v55h-57v-55z",
  fill: "url(#rocket_svg__SVGID_26_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_27_",
  gradientUnits: "userSpaceOnUse",
  x1: 242.314,
  y1: 314.623,
  x2: 281.544,
  y2: 336.764,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#bdccd4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8caab7"
})), React.createElement("path", {
  d: "M278.4 277.5l-1 11.9c-1.4 16.7-8.3 32.5-19.7 44.8l-28.8 31.2c-7.7 8.3-12 19.3-12 30.6v14.1h67.4V252.5c-3.2 8-5.2 16.5-5.9 25z",
  fill: "url(#rocket_svg__SVGID_27_)"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_28_",
  gradientUnits: "userSpaceOnUse",
  x1: 341.27,
  y1: 319.3,
  x2: 408.67,
  y2: 319.3,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#bdccd4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8caab7"
})), React.createElement("path", {
  d: "M347.1 277.5l1 11.9c1.4 16.7 8.3 32.5 19.7 44.8l28.8 31.2c7.7 8.3 12 19.3 12 30.6v14.1h-67.4V252.5c3.2 8 5.2 16.5 5.9 25z",
  fill: "url(#rocket_svg__SVGID_28_)"
}), React.createElement("path", {
  className: "rocket_svg__st32",
  d: "M284.3 252.5h57M284.3 308.5h57"
}), React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_29_",
  gradientUnits: "userSpaceOnUse",
  x1: 308.05,
  y1: 397.75,
  x2: 312.79,
  y2: 397.75,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#57c2be"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00a9e1"
})), React.createElement("path", {
  d: "M308 441.9l4.8 8.5v-81.3l-4.8 16.1v56.7z",
  fill: "url(#rocket_svg__SVGID_29_)"
}), React.createElement("path", {
  d: "M317.5 441.9l-4.7 8.5v-81.3l4.7 16.1v56.7z",
  fill: "#006e8c"
}), React.createElement("path", {
  d: "M306.8 192.9h11.9v5.1h-11.9v-5.1zM301.2 192.9h3.4v5.1h-3.4c-1.4 0-2.5-1.1-2.5-2.5-.1-1.4 1-2.6 2.5-2.6-.1 0 0 0 0 0zM324.4 198H321v-5.1h3.4c1.4 0 2.5 1.1 2.5 2.5.1 1.4-1.1 2.6-2.5 2.6z"
}), React.createElement("path", {
  d: "M341.3 410.1V252.5L358 410.1h-16.7z",
  fill: "#9babb2"
})));

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2284-216.5h5.3c1.1 0 2 .9 2 2v14.4c0 1.1-.9 2-2 2h-5.3c-1.1 0-2-.9-2-2v-14.4c0-1.1.9-2 2-2z",
  fill: "#1a1a1a"
});

var _ref40 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_30_",
  gradientUnits: "userSpaceOnUse",
  x1: -802.606,
  y1: 251.808,
  x2: -756.736,
  y2: 317.198,
  gradientTransform: "rotate(45.001 -105.147 1316.002)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#65d0a7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#4dc4d6"
}));

var _ref41 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 140.3,
  cy: 149.4,
  r: 29.8,
  fill: "url(#rocket_svg__SVGID_30_)"
});

var _ref42 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_31_",
  gradientUnits: "userSpaceOnUse",
  x1: 150.795,
  y1: 114.787,
  x2: 141.485,
  y2: 167.867,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#65d0a7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#4dc4d6"
}));

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.7 128.7l-42.1 42.1c11.9 11.3 30.8 10.9 42.1-1.1 10.9-11.4 10.9-29.5 0-41z",
  fill: "url(#rocket_svg__SVGID_31_)"
});

var _ref44 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "rocket_svg__SVGID_32_",
  gradientUnits: "userSpaceOnUse",
  x1: 268.3,
  y1: 48.2,
  x2: 301.86,
  y2: 48.2,
  gradientTransform: "translate(0 12)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#ff9271"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ffd871"
}));

var _ref45 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 285.1,
  cy: 60.2,
  r: 16.8,
  fill: "url(#rocket_svg__SVGID_32_)"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M297.1 48.6l-23.7 23.7c6.6 6.5 17.2 6.4 23.7-.2 6.5-6.5 6.5-17 0-23.5z",
  fill: "#fbb03b"
});

var SvgRocket = function SvgRocket(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "rocket_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 599 598",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46);
};

export default __webpack_public_path__ + "static/media/rocket.584cfdec.svg";
export { SvgRocket as ReactComponent };